import { Money } from '@ap/interface-bspc-core';
import { Applicant } from '@ap/ap-interface-apix-hypotheken-berekening';

export class ApplicantBuilder {
    private income: Money;
    private dateOfBirth?: Date;

    withIncome(income: Money) {
        this.income = income;
        return this;
    }

    withDateOfBirth(dateOfBirth: Date) {
        this.dateOfBirth = dateOfBirth;
        return this;
    }

    build(): Applicant {
        return {
            income: this.income,
            date_of_birth: this.dateOfBirth
        } as Applicant;
    }
}
